import React, { Component } from 'react';
import { createForm } from 'rc-form';
import get from 'lodash/get';
import { FormattedMessage } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import Select from 'react-select';

import Text from 'ui/Text';
import Button from 'ui/Button';
import axios from 'utils/axios';
import Auth from 'shared/Auth';

class SignUpForm extends Component {
  constructor() {
    super();

    this.state = {
      countries: [],
      errorMessage: '',
      successMessage: '',
      loading: false,
      requiredText: get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Champs obligatoires' : 'Required',
    };
  }

  componentDidMount() {
    axios
      .get('/country')
      .then((res) => {
        this.setState({
          loading: false,
          countries: res.data,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error,
        });
      });
  }

  onSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((formError, values) => {
      if (formError) {
        return;
      }

      this.setState({
        errorMessage: '',
        successMessage: '',
        loading: true,
      });

      // value not required
      delete values.confirm_password;

      const newValues = {
        ...values,
        country: get(values, 'country.value'),
        locale: get(Auth.getLanguage(), 'lang'),
      };

      axios
        .post('/auth/register', newValues)
        .then(() => {
          this.setState({
            loading: false,
            successMessage: <FormattedMessage 
                              id="Form.SuccessSignUp" 
                              defaultMessage="'You have been successfully registered. Kindly Login to Start the Application Process'" />,
          });

          this.props.history.push('/login');
        })
        .catch((error) => {
          this.setState({
            loading: false,
            errorMessage: get(error, 'response.data.message') || error,
          });
        });
      });
    };
    
    render() {
      const { getFieldDecorator, getFieldError } = this.props.form;

      const langMap = {
        en_US: 'Name',
        fr_FR: 'Name_fr',
      };

      const currentLanguage = get(Auth.getLanguage(), 'lang');

      const labelKey = get(langMap, currentLanguage);      
      
      const countryOptions = this.state.countries.map(country => ({
      label: get(country, labelKey),
      value: get(country, 'Code'),
    }));

    return (
      <form onSubmit={this.onSubmit} className="signup-form">
        <div className={this.state.loading ? 'text-center waiting' : 'hidden'}>
          <Text>Submitting Info ...</Text>
        </div>
        <div className={this.state.errorMessage ? 'alert' : 'hidden'}>
          <Text type="explanation" modifiers="normal__smaller">
            {`${this.state.errorMessage}`}
          </Text>
        </div>
        <div className={this.state.successMessage ? 'alert success' : 'hidden'}>
          <Text type="explanation" modifiers="normal__smaller">
            {`${this.state.successMessage}`}
          </Text>
        </div>
        <div className="signup-form__field">
          <label htmlFor="organisation">
            <FormattedMessage id="Form.OrganisationName" defaultMessage="Organisation Name" />
          </label>
          {getFieldDecorator('organisation', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: `${this.state.requiredText}`,
              },
            ],
          })(<input id="organisation" type="text" className="signup-form__form-control" />)}
          <div className={getFieldError('organisation') ? 'error' : 'hidden'}>
            {(getFieldError('organisation') || []).join(', ')}
          </div>
        </div>
        <div className="signup-form__field">
          <label htmlFor="applicant_name">
            <FormattedMessage id="Form.ApplicantName" defaultMessage="Applicant Name" />
          </label>
          {getFieldDecorator('names', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: `${this.state.requiredText}`,
              },
            ],
          })(<input type="text" className="signup-form__form-control" />)}
          <div className={getFieldError('names') ? 'error' : 'hidden'}>
            {(getFieldError('names') || []).join(', ')}
          </div>
        </div>
        <div className="signup-form__field">
          <label htmlFor="email">
            <FormattedMessage id="Form.EmailAddress" defaultMessage="Email Address" />
          </label>
          {getFieldDecorator('email', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: `${this.state.requiredText}`,
              },
            ],
          })(<input type="email" className="signup-form__form-control" />)}
          <div className={getFieldError('email') ? 'error' : 'hidden'}>
            {(getFieldError('email') || []).join(', ')}
          </div>
        </div>
        <div tabIndex="1" className="signup-form__field">
          <label htmlFor="country">
            <FormattedMessage id="Form.Country" defaultMessage="Country" />
          </label>
          {getFieldDecorator('country', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: `${this.state.requiredText}`,
              },
            ],
          })(
            <Select
              className="country-form-container"
              classNamePrefix="country-form"
              placeholder={
                <FormattedMessage id="Form.SelectCountry" defaultMessage="Select a Country" />
              }
              options={countryOptions}
            />,
          )}
          <div className={getFieldError('country') ? 'error' : 'hidden'}>
            {(getFieldError('country') || []).join(', ')}
          </div>
        </div>
        <div className="signup-form__field">
          <label htmlFor="password">
            <FormattedMessage id="Form.Password" defaultMessage="Password" />
          </label>
          {getFieldDecorator('password', {
            initialValue: '',
            rules: [
              {
                required: true,
                message: `${this.state.requiredText}`,
              },
            ],
          })(<input type="password" className="signup-form__form-control" />)}
          <div className={getFieldError('password') ? 'error' : 'hidden'}>
            {(getFieldError('password') || []).join(', ')}
          </div>
        </div>
        <div className="signup-form__field">
          <label htmlFor="confirm_password">
            <FormattedMessage id="Form.ConfirmPassword" defaultMessage="Confirm Password" />
          </label>
          {getFieldDecorator('confirm_password', {
            initialValue: '',
            rules: [
              {
                validator: (rule, value, callback) => {
                  const form = this.props.form;
                  const firstPassword = form.getFieldValue('password');
                  const secondPassword = form.getFieldValue('confirm_password');

                  let msg = get(Auth.getLanguage(), 'local_locale') === 'fr' ? 'Pas pareil' : 'Not Similar';

                  if (!firstPassword.match(secondPassword)) {
                    callback(msg);
                  } else {
                    callback();
                  }
                },
              },
            ],
          })(<input type="password" className="signup-form__form-control" />)}
          <div className={getFieldError('confirm_password') ? 'error' : 'hidden'}>
            {(getFieldError('confirm_password') || []).join(', ')}
          </div>
        </div>
        <Button type="submit" nature="primary">
          <FormattedMessage id="SignUp" defaultMessage="Sign Up" />
        </Button>
        <Link to="/login">
          <Text type="small" modifiers="pure-white helper-link">
            <FormattedMessage id="LoginRedirect" defaultMessage="Already have an account? Login" />
          </Text>
        </Link>
      </form>
    );
  }
}

const WrappedSignUpForm = createForm()(SignUpForm);

const WrappedRouterSignUpForm = withRouter(WrappedSignUpForm);

export default WrappedRouterSignUpForm;



// WEBPACK FOOTER //
// ./src/components/HomePage/SignUpForm.js